__turbopack_context__.v({
  "border_right": "StatsContainerFaq-module-scss-module__RIwM-q__border_right",
  "statics_container": "StatsContainerFaq-module-scss-module__RIwM-q__statics_container",
  "stats": "StatsContainerFaq-module-scss-module__RIwM-q__stats",
  "text1": "StatsContainerFaq-module-scss-module__RIwM-q__text1",
  "text2": "StatsContainerFaq-module-scss-module__RIwM-q__text2",
});
